import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class LatestNews {
    constructor() {
        this.section = document.querySelector('.components-block-latest-news');
        this.slider = this.section.querySelector('.swiper');
        this.navigationPrev = this.section.querySelector('.slider-button-prev');
        this.navigationNext = this.section.querySelector('.slider-button-next');
        this.navigationPrevMobile = this.section.querySelector('.slider-button-prev-mobile');
        this.navigationNextMobile = this.section.querySelector('.slider-button-next-mobile');
        this.pagination = this.section.querySelector('.swiper-pagination-nav');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 'auto',
            spaceBetween: 32,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    pagination: {
                        el: this.pagination,
                        type: 'fraction',
                    },
                    navigation: {
                        nextEl: this.navigationNextMobile,
                        prevEl: this.navigationPrevMobile,
                    },
                },
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    pagination: {
                        el: this.pagination,
                        type: 'fraction',
                    },
                    navigation: {
                        nextEl: this.navigationNextMobile,
                        prevEl: this.navigationPrevMobile,
                    },
                },
                1024: {
                    slidesPerView: 'auto',
                    pagination: '',
                },
            },
        });
    }
}

if (document.querySelector('.components-block-latest-news')) {
    new LatestNews();
}
